import React, {memo} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles = makeStyles((theme) => ({
    root: {},
    header: {},
    content: {
        padding: 0,
    },
    inner: {
        minWidth: 660
    },
    table: {
        [theme.breakpoints.down('md')]: {
            tableLayout: 'fixed',
        },
    },
    td: {
        textAlign: 'center',
        padding: '10px 2px',
        border: `1px solid ${theme.palette.grey.A100}`,
    },
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    status: {
        marginRight: theme.spacing(1),
    },
    up: {
        color: theme.palette.error.main,
    },
    down: {
        color: theme.palette.info.main,
    },
    middle: {
        marginLeft: theme.spacing(-1),
        color: theme.palette.black,
    },
    caption: {
        marginLeft: theme.spacing(1),
    },
}));

const Top5Point = memo(props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);

    if (!data) return null;

    const createTableBody = () => {
        const maxRow = data.reduce((acc, cur) => Math.max(acc, cur.datasets.length), 0);
        let body = [];

        for (let i = 0; i < maxRow; i++) {
            body.push(
                <TableRow
                    hover
                    key={i}
                >
                    <TableCell
                        className={classes.td}
                    >{i + 1}</TableCell>
                    {data.map((point, idx) => (
                        <React.Fragment key={idx}>
                            <TableCell
                                className={classes.td}
                            >{point.datasets[i] && point.datasets[i].platform}</TableCell>
                            <TableCell
                                className={classes.td}
                            >{point.datasets[i] && `${point.datasets[i].point}p`}</TableCell>
                        </React.Fragment>
                    ))}
                </TableRow>
            );
        }

        return body;
    };

    return (
        <>
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >
                <CardHeader
                    title="Revenue by Platform of Top 5 Manufacturers"
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.td}>Rank</TableCell>
                                        {data.map((point, i) => (
                                            <TableCell
                                                className={classes.td}
                                                colSpan={2}
                                                key={i}
                                            >{point.company}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {createTableBody()}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                <Divider/>
            </Card>
        </>
    );
});

Top5Point.propTypes = {
    className: PropTypes.string,
    data: PropTypes.any,
};

export default Top5Point;
